var _rect, _rect2, _polygon, _polygon2, _polygon3, _g, _rect3, _rect4, _path, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuiltFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 275,
    viewBox: "0 0 300 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    width: 150,
    height: 100,
    fill: "#e55c17"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 100,
    fill: "#f7d2ba"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "150 100 0 100 75 25 150 100",
    fill: "#e8aa9c"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "150 275 150 200 225 200 150 275",
    fill: "#e55c17"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "225 200 225 275 150 275 225 200",
    fill: "#f7d2ba"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 200,
    width: 75,
    height: 75,
    fill: "#e8aa9c"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.5,
    cy: 237.5,
    r: 22.5,
    fill: "#fbefe6"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 100,
    width: 150,
    height: 175,
    fill: "#214f0a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 100,
    width: 150,
    height: 100,
    fill: "#f7d2ba"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.87,200.62c0-41.42,33.58-75,75-75s75,33.58,75,75",
    fill: "#fbefe6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.87,125.62v75h75c0-41.42-33.58-75-75-75Z",
    fill: "#214f0a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.5,155.22c0,20.71-16.79,37.5-37.5,37.5s-37.5-16.79-37.5-37.5",
    fill: "#fbefe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5,219.78c0-20.71,16.79-37.5,37.5-37.5s37.5,16.79,37.5,37.5",
    fill: "#fbefe6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiltFull);
export default __webpack_public_path__ + "static/media/quilt-full.3d0ebb77f9dc8a46e7a0390bb4011d43.svg";
export { ForwardRef as ReactComponent };